import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createBlock as _createBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["rootClass"]

interface IProps {
  modelValue: number
  perPage: number
  mini?: boolean
  total?: number
  useInput?: boolean
  rootClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
  disable?: boolean
  perPageOptions: { label: string | number; value: string | number }[]
}

interface IEmits {
  (event: 'update:modelValue', data: number): void
  (event: 'update:perPage', data: number): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KPagination', inheritAttrs: false },
  __name: 'KPagination',
  props: {
    modelValue: {},
    perPage: {},
    mini: { type: Boolean, default: false },
    total: { default: 0 },
    useInput: { type: Boolean, default: false },
    rootClass: { default: '' },
    disable: { type: Boolean, default: false },
    perPageOptions: { default: () => [
    { label: '3', value: 3 },
    { label: '5', value: 5 },
    { label: '7', value: 7 },
    { label: '10', value: 10 },
    { label: '15', value: 15 },
    { label: '20', value: 20 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
  ] }
  },
  emits: ["update:modelValue", "update:perPage"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const updateInput = (value: string) => {
  const numberInput = Number(value) || 0
  if (numberInput > 0) {
    emit('update:perPage', numberInput)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_KInput = _resolveComponent("KInput")!
  const _component_KDropdown = _resolveComponent("KDropdown")!
  const _component_q_pagination = _resolveComponent("q-pagination")!

  return (_openBlock(), _createElementBlock("div", {
    class: "k-pagination row items-center",
    rootClass: [__props.rootClass]
  }, [
    (!__props.mini)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["fs-13px q-mr-sm", { 'text-cool-gray-70': __props.disable }])
        }, "Show :", 2))
      : _createCommentVNode("", true),
    (__props.useInput)
      ? (_openBlock(), _createBlock(_component_KInput, {
          key: 1,
          "model-value": __props.perPage,
          options: __props.perPageOptions,
          small: "",
          dense: "",
          class: "k-pagination__input q-mr-sm",
          mask: "##",
          "has-clear-icon": false,
          disable: __props.disable,
          onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (updateInput($event.target.value)), ["enter"]))
        }, null, 8, ["model-value", "options", "disable"]))
      : (_openBlock(), _createBlock(_component_KDropdown, {
          key: 2,
          "model-value": __props.perPage,
          options: __props.perPageOptions,
          small: "",
          dense: "",
          class: "q-mr-sm",
          disable: __props.disable,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:perPage', $event)))
        }, null, 8, ["model-value", "options", "disable"])),
    (!__props.mini)
      ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          class: _normalizeClass(["fs-13px q-ml-xs q-mr-lg", { 'text-cool-gray-70': __props.disable }])
        }, " per page ", 2))
      : (_openBlock(), _createElementBlock("span", {
          key: 4,
          class: _normalizeClass(["fs-13px q-mr-12", { 'text-cool-gray-70': __props.disable }])
        }, " Of " + _toDisplayString(__props.total), 3)),
    _createVNode(_component_q_pagination, _mergeProps({
      "model-value": __props.modelValue,
      class: ['k-pagination__main', 'q-pr-sm', { 'mini-pagination': __props.mini }],
      "direction-links": "",
      "active-design": "flat",
      "active-color": "cool-gray-100",
      color: "cool-gray-70",
      "max-pages": 6,
      max: ""
    }, _ctx.$attrs, {
      disable: __props.disable,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }), null, 16, ["model-value", "class", "disable"])
  ], 8, _hoisted_1))
}
}

})